// import React, { useEffect, useState } from "react";
// import { Modal } from "react-bootstrap";
// import profilePic from "../../assets/images/masterdatapic/profilePic.png";
// import ReactFlagsSelect from "react-flags-select";
// import Select from "react-select";
// import { useTranslation } from "react-i18next";
// import Params from "../../config/Params";
// import useParams from "../../config/useParams";
// import { simplePostCall } from "../../api/ApiServices";
// import ApiConfig from "../../api/ApiConfig";
// import { useSearchParams } from "react-router-dom";

// function TeacherDetailsView() {
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [showblockModal, setShowBlockModal] = useState(false);
//   const [showresignModal, setShowResignModal] = useState(false);
//      const [params, setParams] = useParams();
//      const [teacherDetails, setTeacherDetails] = useState([]);
//     // const uid = params.get("message");
//  const [searchParams] = useSearchParams()
//   const [country, setCountry] = useState("");
//   const { t } = useTranslation(); 
//   const teacherdetails = [
//     {
//       email: "ashick@mailinator.com",
//       phone: "+91 5588554455",
//       status: "Verified",
//     },
//   ];
//   const teachersubject = [
//     {
//       teachernum: "1",
//       gradeanddivision: "10 A",
//       subjectname: "Maths , Social Science",
//     },
//   ];
//   const gender = [
//     { value: "Male", label: "Male" },
//     { value: "Female", label: "Female" },
//     { value: "Others", label: "Others" },
//   ];


//    const getUserInfo = (id) => {
// console.log('params--',params)
//     simplePostCall(ApiConfig.GET_TEACHER_DETAILS, JSON.stringify({
//       "customer_id": Params.customer_id,
//       "api_key": Params.api_key,
//       "id": id,
//       "language": "en"
//     })).then((res) => {

//       if (res?.result) {

//         let userDetails = res?.data[0] || {}

//         // setSelected(userDetails?.user_nationality)
//         let obj = {}

//         userDetails?.teacher_classes?.forEach((i, index) => {

//           obj[i?.class_division_id] = []

//         })

//         // setShowSelected(obj)

//         setTeacherDetails({
//           firstName: userDetails?.first_name,
//           lastName: userDetails?.last_name,
//           address: userDetails?.user_address,
//           city: userDetails?.user_city,
//           contactNumber: userDetails?.user_mobile,
//           email: userDetails?.user_email,
//           nationality: userDetails?.user_nationality,
//           userPassword: userDetails,
//           conformPassword: "",
//           dateofbirth: userDetails?.user_dob || '',
//           gender: userDetails?.user_gender,
//           qualification: userDetails?.teacher_qualification,
//           designation: userDetails?.teacher_designation,
//           joiningdate: userDetails?.user_joining_date,
//           staffid: userDetails?.staff_id || '',
//           uploadfile: userDetails?.user_profile_pic,
//           reportingperson: userDetails?.teacher_reporting_person,
//           userstaffmap: "",
//           teachercirculum: userDetails?.teacher_curriculum,
//           firstName_error: "",
//           contactNumber_error: "",
//           email_error: "",
//           userPassword_error: "",
//           conformPassword_error: "",
//           designation_error: "",
//         })
//       }

//     })

//   }

//     useEffect(()=>{
//         const id = searchParams.get("id")
//       getUserInfo(id);
//     },[])
//   return (
//     <>
//       <div className="row edsys-table">
//         <div className="col-sm-12">
//           <div className="d-flex">
//             <h5 className="mb-2 flex-grow-1">{t("Teacher Details")}</h5>
//             {/* <div className="tablebuttonview">
//               <a
//                 href="/EditTeacher"
//                 type="button"
//                 className="btn timetablebutton "
//               >
//                 <span>{t("Edit")}</span>
//               </a>
//               <a
//                 href="/ChangePassword"
//                 type="button"
//                 className="btn timetablebutton "
//               >
//                 <span>{t("Change Password")}</span>
//               </a>
//               <a
//                 type="button"
//                 className="btn timetablebutton"
//                 onClick={() => setShowBlockModal(true)}
//               >
//                 <span>{t("Block")}</span>
//               </a>

//               <a
//                 type="button"
//                 className="btn timetablebutton"
//                 onClick={() => setShowResignModal(true)}
//               >
//                 <span>{t("Resigned")}</span>
//               </a>
//               <a
//                 type="button"
//                 className="btn timetablebutton"
//                 onClick={() => setShowDeleteModal(true)}
//               >
//                 <span>{t("Delete")}</span>
//               </a>
//             </div> */}
//           </div>
//           <br />
//           <div className="row card-div">
//             <div className="card col-md-5">
//               <div className="card-header">
//                 <div className="teacher_profile_div">
//                   <img src={profilePic} className="teacher_profile" />
//                   <label for="task-title">{t("Ashick")}</label> <br />
//                 </div>
//                 <h6 className="mb-2 flex-grow-1">{t("Contact Information")}</h6>
//                 {teacherdetails.map((item) => (
//                   <>
//                     <div style={{ display: "flex" }}>
//                       <label
//                         className="labelcolor"
//                         style={{ width: "15%" }}
//                         for="task-title"
//                       >
//                         {t("Email")}
//                       </label>
//                       <label style={{ width: "40%" }}>{item.email}</label>
//                     </div>
//                     <div style={{ display: "flex" }}>
//                       <label
//                         className="labelcolor"
//                         style={{ width: "15%" }}
//                         for="task-title"
//                       >
//                         {t("Phone")}
//                       </label>
//                       <label style={{ width: "40%" }}>{item.phone}</label>
//                     </div>
//                     <div style={{ display: "flex" }}>
//                       <label
//                         className="labelcolor"
//                         style={{ width: "15%" }}
//                         for="task-title"
//                       >
//                        {t("Email Status")} 
//                       </label>
//                       <label style={{ width: "40%" }}>{item.status}</label>
//                     </div>
//                   </>
//                 ))}
//               </div>
//             </div>
//             <div className="card col-md-5">
//               <div className="card-header">
//                 <h6 className="mb-2 flex-grow-1">{t("Personal Information")}</h6>
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "7px",
//                   }}
//                 >
//                   <div style={{ display: "flex" }}>
//                     <label className="labelcolor" for="task-title">
//                     {t("Address")}
//                     </label>
//                     <label className="label2">
//                     {t("mannna villa Thiruvanamthapuram")} 
//                     </label>
//                   </div>
//                   <div style={{ display: "flex" }}>
//                     <label className="labelcolor" for="task-title">
//                     {t("City")}  
//                     </label>
//                     <label className="label2">{t("Thiruvananthapuram")}</label>
//                   </div>
//                   <div style={{ display: "flex" }}>
//                     <label className="labelcolor" for="task-title">
//                     {t("Nationality")} 
//                     </label>
//                     <label className="label2">{t("United Arab Emirates")}</label>
//                   </div>
//                   <div style={{ display: "flex" }}>
//                     <label className="labelcolor" for="task-title">
//                     {t("Date of Birth")} 
//                     </label>
//                     <label className="label2">{t("United Arab Emirates")}</label>
//                   </div>
//                   <div style={{ display: "flex" }}>
//                     <label className="labelcolor" for="task-title">
//                     {t("Gender")}  
//                     </label>
//                     <label className="label2">{t("United Arab Emirates")}</label>
//                   </div>

//                   <div style={{ display: "flex" }}>
//                     <label className="labelcolor" for="task-title">
//                     {t("Status")}  
//                     </label>
//                     <label className="label2">{t("United Arab Emirates")}</label>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="row card-div">
//             <div className=" card col-md-5">
//               <div className="card-header">
//                 <h6 className="mb-2 flex-grow-1">{t("Professional Information")}</h6>
//                 <div style={{ display: "flex" }}>
//                   <label className="labelcolor" for="task-title">
//                   {t("User Join Date")} 
//                   </label>
//                   <label className="label2">{t("Thu Apr 27 2023")}</label>
//                 </div>
//                 <div style={{ display: "flex" }}>
//                   <label className="labelcolor" for="task-title">
//                   {t("Qualification")} 
//                   </label>
//                   <label className="label2"></label>
//                 </div>
//                 <div style={{ display: "flex" }}>
//                   <label className="labelcolor" for="task-title">
//                   {t("Designation")} 
//                   </label>
//                   <label className="label2">{t("Professor")}</label>
//                 </div>
//                 <div style={{ display: "flex" }}>
//                   <label className="labelcolor" for="task-title">
//                   {t("Teacher Curriculum")} 
//                   </label>
//                   <label className="label2">{t("Mathematicss")}</label>
//                 </div>
//                 <div style={{ display: "flex" }}>
//                   <label className="labelcolor" for="task-title">
//                   {t("Teacher Class")}
//                   </label>
//                   <label className="label2"></label>
//                 </div>
//                 <div style={{ display: "flex" }}>
//                   <label className="labelcolor" for="task-title">
//                   {t("Supervisor Class")}
//                   </label>

//                   <label className="label2"></label>
//                 </div>
//               </div>
//             </div>
//             <div className="card col-md-5">
//               <div className="card-header">
//                 <div className="table-responsive">
//                   <table className="table">
//                     <thead>
//                       <tr>
//                         <th scope="col">SR.NO</th>
//                         <th scope="col">Grade And Division</th>
//                         <th scope="col">Subject Name</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {teachersubject.map((item) => {
//                         return (
//                           <tr>
//                             <th scope="row">{item.teachernum}</th>
//                             <td>{item.gradeanddivision}</td>
//                             <td>{item.subjectname}</td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Modal Start */}

//       <Modal
//         show={showDeleteModal}
//         onHide={() => setShowDeleteModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title id="contained-modal-title-vcenter border-bottom">
//           {t("Delete Confirmation")}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="delete-text-wrapper">
//           {t("Are you sure you want to delete ?")} 
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <div className="delete-btn-wrapper border-top w-100">
//             <button
//               onClick={() => setShowDeleteModal(false)}
//               className="dlt-btn-1"
//             >
//               {t("Cancel")}
//             </button>
//             <button
//               onClick={() => setShowDeleteModal(false)}
//               type="submit"
//               className="dlt-btn-2"
//               value="delete"
//             >
//             {t("Delete")}  
//             </button>
//           </div>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Modal End */}
//       {/* Block Modal Start */}

//       <Modal
//         show={showblockModal}
//         onHide={() => setShowBlockModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title id="contained-modal-title-vcenter border-bottom">
//           {t("Block Confirmation")} 
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="delete-text-wrapper">
//           {t("Do you really want to block ?")} 
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <div className="delete-btn-wrapper border-top w-100">
//             <button
//               onClick={() => setShowBlockModal(false)}
//               className="dlt-btn-1"
//             >
//              {t("Cancel")} 
//             </button>
//             <button
//               onClick={() => setShowBlockModal(false)}
//               type="submit"
//               className="dlt-btn-2"
//               value="delete"
//             >
//              {t("Ok")}
//             </button>
//           </div>
//         </Modal.Footer>
//       </Modal>

//       {/* Block Modal End */}

//       {/* Resign Modal Start */}

//       <Modal
//         show={showresignModal}
//         onHide={() => setShowResignModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title id="contained-modal-title-vcenter border-bottom">
//           {t("Resign Confirmation")} 
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="delete-text-wrapper">
//           {t("Are you sure you want to resign ?")} 
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <div className="delete-btn-wrapper border-top w-100">
//             <button
//               onClick={() => setShowResignModal(false)}
//               className="dlt-btn-1"
//             >
//              {t("Cancel")}
//             </button>
//             <button
//               onClick={() => setShowResignModal(false)}
//               type="submit"
//               className="dlt-btn-2"
//               value="delete"
//             >
//             {t("Ok")}  
//             </button>
//           </div>
//         </Modal.Footer>
//       </Modal>

//       {/* Resign Modal End */}
//     </>
//   );
// }

// export default TeacherDetailsView;



import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import profilePic from "../../assets/images/masterdatapic/profilePic.png";
import { useTranslation } from "react-i18next";
import Params from "../../config/Params";
import useParams from "../../config/useParams";
import placeholderPicture from "../../assets/images/user/placeholder-profile-picture.jpg";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig, { BASE_URL } from "../../api/ApiConfig";
import { useSearchParams } from "react-router-dom";

function TeacherDetailsView() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showblockModal, setShowBlockModal] = useState(false);
  const [showresignModal, setShowResignModal] = useState(false);
  

  const [params, setParams] = useParams();
  const [teacherDetails, setTeacherDetails] = useState({});
  const [searchParams] = useSearchParams();
  const [curriculum , setCurriculum] = useState([]);
  const [curriculumName , setCurriculumName] = useState('');

  const { t } = useTranslation();

  const getUserInfo = (id) => {
    simplePostCall(
      ApiConfig.GET_TEACHER_DETAILS,
      JSON.stringify({
        customer_id: Params.customer_id,
        api_key: Params.api_key,
        id: id,
        language: "en",
      })
    ).then((res) => {
      if (res?.result) {
        const userDetails = res?.data?.[0] || {};

        setTeacherDetails({
          firstName: userDetails?.first_name,
          lastName: userDetails?.last_name,
          address: userDetails?.user_address,
          city: userDetails?.user_city,
          contactNumber: userDetails?.user_mobile,
          email: userDetails?.user_email,
          nationality: userDetails?.user_nationality,
          dateofbirth: userDetails?.user_dob || "",
          gender: userDetails?.user_gender,
          qualification: userDetails?.teacher_qualification,
          designation: userDetails?.teacher_designation,
          joiningdate: userDetails?.user_joining_date,
          staffid: userDetails?.staff_id || "",
          uploadfile: userDetails?.user_profile_pic,
          reportingperson: userDetails?.teacher_reporting_person,
          teachercirculum: userDetails?.teacher_curriculum,
          userPassword: userDetails,
        });
      }
    });
  };

  useEffect(() => {
    const id = searchParams.get("id");
    getUserInfo(id);
    CurriculumTeacher();
  }, []);


   const CurriculumTeacher = () => {
      let RequestBody = JSON.stringify({
        api_key: Params.api_key,
        customer_id: Params.customer_id,
      });
      simplePostCall(ApiConfig.TEACHER_CURRICULUM, RequestBody)
        .then((data) => {
         setCurriculum(data?.list || [])
        })
        .catch((error) => {
          console.log(error, "Error");
        });
    };
    const filterCurriculam =(array , id) => {
      if(array?.length > 0 && id) {
        const cur =  array.filter(item => item?.curriculum_id == id);
        return cur ; 
      }
    }

    useEffect(()=>{
        if(teacherDetails?.teachercirculum && curriculum?.length > 0) {
        const curi =  filterCurriculam(curriculum , teacherDetails?.teachercirculum ) ;
        // const curi = 'yes' 
        console.log('taleeb_curi--', curi )
       setCurriculumName(curi?.[0]?.curriculum_name);
        }
    }, [teacherDetails?.teachercirculum , curriculum])
  return (
    <>
      <div className="row edsys-table">
        <div className="col-sm-12">
          <div className="d-flex">
            <h5 className="mb-2 flex-grow-1">{t("Teacher Details")}</h5>
          </div>

          <br />

          {/* ================= PROFILE + CONTACT ================= */}
          <div className="row card-div">
            <div className="card col-md-5">
              <div className="card-header">
                <div className="teacher_profile_div">
                  <img
                    src={
                      teacherDetails.uploadfile
                        ? `${BASE_URL}${teacherDetails.uploadfile}`
                        : placeholderPicture
                    }
                    className="teacher_profile"
                    alt="profile"
                        onError={(e)=>{e.target.src = placeholderPicture}}
                  />
                  <label>
                    {teacherDetails.firstName} {teacherDetails.lastName}
                  </label>

                </div>
<br />
                <h6 className="mb-2 flex-grow-1">
                  {t("Contact Information")}
                </h6>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor" >
                    {t("Email")}
                  </label>
                  <label >
                    {teacherDetails.email}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor" >
                    {t("Phone")}
                  </label>
                  <label >
                    {teacherDetails.contactNumber}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor" >
                    {t("Email Status")}
                  </label>
                  <label >
                    {teacherDetails.userPassword?.user_email_verification}
                  </label>
                </div>
              </div>
            </div>

            {/* ================= PERSONAL INFO ================= */}
            <div className="card col-md-5">
              <div className="card-header">
                <h6 className="mb-2 flex-grow-1">
                  {t("Personal Information")}
                </h6>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("Address")}</label>
                  <label className="label2">
                    {teacherDetails.address}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("City")}</label>
                  <label className="label2">
                    {teacherDetails.city}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("Nationality")}</label>
                  <label className="label2">
                    {teacherDetails.nationality}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("Date of Birth")}</label>
                  <label className="label2">
                    {teacherDetails.dateofbirth}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("Gender")}</label>
                  <label className="label2">
                    {teacherDetails.gender === "f" ? "Female" : "Male"}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("Status")}</label>
                  <label className="label2">
                    {teacherDetails.userPassword?.user_status}
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* ================= PROFESSIONAL INFO ================= */}
          <div className="row card-div">
            <div className="card col-md-5">
              <div className="card-header">
                <h6 className="mb-2 flex-grow-1">
                  {t("Professional Information")}
                </h6>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("User Join Date")}</label>
                  <label className="label2">
                    {teacherDetails.joiningdate}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("Qualification")}</label>
                  <label className="label2">
                    {teacherDetails.qualification}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("Designation")}</label>
                  <label className="label2">
                    {teacherDetails.designation}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">
                    {t("Teacher Curriculum")}
                  </label>
                  <label className="label2">
                    { curriculumName }
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">{t("Teacher Class")}</label>
                  <label className="label2">
                    {teacherDetails.userPassword?.teacher_classes
                      ?.map((cls) => cls.class_name)
                      .join(", ")}
                  </label>
                </div>

                <div style={{ display: "flex" }}>
                  <label className="labelcolor">
                    {t("Supervisor Class")}
                  </label>
                  <label className="label2">
                    {teacherDetails.userPassword?.supervisor_classes
                      ?.map((cls) => cls.class_name)
                      .join(", ")}
                  </label>
                </div>
              </div>
            </div>

            {/* ================= SUBJECT TABLE ================= */}
            <div className="card col-md-5">
              <div className="card-header">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>SR.NO</th>
                        <th>Grade And Division</th>
                        <th>Subject Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {teacherDetails.userPassword?.teacher_subjects?.map(
                        (item, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{item.class_name}</td>
                            <td>
                              {item.subjects
                                .map((sub) => sub.subject_name)
                                .join(", ")}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= MODALS (UNCHANGED) ================= */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Delete Confirmation")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("Are you sure you want to delete ?")}</Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowDeleteModal(false)}>
            {t("Cancel")}
          </button>
          <button onClick={() => setShowDeleteModal(false)}>
            {t("Delete")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showblockModal}
        onHide={() => setShowBlockModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Block Confirmation")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("Do you really want to block ?")}</Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowBlockModal(false)}>
            {t("Cancel")}
          </button>
          <button onClick={() => setShowBlockModal(false)}>
            {t("Ok")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showresignModal}
        onHide={() => setShowResignModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Resign Confirmation")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("Are you sure you want to resign ?")}
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowResignModal(false)}>
            {t("Cancel")}
          </button>
          <button onClick={() => setShowResignModal(false)}>
            {t("Ok")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TeacherDetailsView;
